import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'

export const skladOstatkiDownloadAsExcel = (dataArray) => {
	const allSerials = dataArray.flatMap((item) => item.SerialsInStock || [])

	// Group by warehouse name
	const warehouseMap = {}
	allSerials.forEach((serial) => {
		const whsName = serial.WhsName || 'Без имени'
		if (!warehouseMap[whsName]) {
			warehouseMap[whsName] = []
		}
		warehouseMap[whsName].push(serial)
	})

	// Column headers mapping
	const columnMapping = {
		ItemName: 'Товар',
		U_Group: 'Группа товара',
		IntrSerial: 'ИМЕИ',
		U_Condition: 'Состояние',
		U_Color: 'Цвет',
		U_Memory: 'Память',
		U_Percent: 'Ёмкость',
		CardName: 'Поставщик',
		U_ShopfrontPrice: 'Цена продажи',
		CostTotal: 'Цена закупки',
		WhsName: 'Имя склада',
		U_Box: 'Коробка',
	}

	const workbook = XLSX.utils.book_new()

	Object.entries(warehouseMap).forEach(([whsName, serials]) => {
		const mappedData = serials.map((serial) => {
			const mappedRow = {}
			Object.keys(columnMapping).forEach((key) => {
				mappedRow[columnMapping[key]] = serial[key] ?? '-'
			})
			return mappedRow
		})

		// Clean sheet name (Excel limits names to 31 chars and forbids some characters)
		const safeSheetName = whsName.slice(0, 31).replace(/[:\\/?*\[\]]/g, '')

		const worksheet = XLSX.utils.json_to_sheet(mappedData)
		XLSX.utils.book_append_sheet(workbook, worksheet, safeSheetName)
	})

	const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
	const blob = new Blob([wbout], { type: 'application/octet-stream' })
	saveAs(blob, 'Склад остатка.xlsx')
}
